import request from '../http';

const filterProdMenus = (menus) => {
  if (process.env.NODE_ENV !== 'production') return menus;
  if (!Array.isArray(menus)) return menus;
  
  const hideKeywords = [];
  return menus
    .filter(menu => {
      const name = menu.name || '';
      return !hideKeywords.some(kw => name.includes(kw));
    })
    .map(menu => {
      if (menu.children && menu.children.length > 0) {
        return { ...menu, children: filterProdMenus(menu.children) };
      }
      return menu;
    });
};

const processMenuResponse = async (reqPromise) => {
  const res = await reqPromise;
  if (process.env.NODE_ENV === 'production') {
    if (res && Array.isArray(res.data)) {
      res.data = filterProdMenus(res.data);
    } else if (Array.isArray(res)) {
      return filterProdMenus(res);
    }
  }
  return res;
};

export const listMenus = (params) =>
  request({ url: '/system/menus', method: 'get', params });

export const getMenuTree = (params) =>
  request({ url: '/system/menus/tree', method: 'get', params });

/** 当前用户可访问的菜单树（用于左侧导航，按权限隐藏） */
export const getMyMenus = () =>
  processMenuResponse(request({ url: '/system/menus/my', method: 'get' }));

export const createMenu = (data) =>
  request({ url: '/system/menus', method: 'post', data });

export const updateMenu = (id, data) =>
  request({ url: `/system/menus/${id}`, method: 'put', data });

export const deleteMenu = (id) =>
  request({ url: `/system/menus/${id}`, method: 'delete' });
